<template>
    <div class="dialog_section detail-content">
        <div class="detail_title" style="margin-top: 0.1rem">车辆基础信息</div>
        <el-row class="detail_form">
            <el-col :span="8">
                车牌号：<b>{{ detailForm && detailForm.plateNo != null ? detailForm.plateNo : '--' }}</b>
            </el-col>
            <el-col :span="8">
                车架号：<b>{{ detailForm && detailForm.vin != null ? detailForm.vin : '--' }}</b>
            </el-col>
            <el-col :span="8">
                设备绑定时间：<b>{{ detailForm && detailForm.activationTime != null ? detailForm.activationTime : '--' }}</b>
            </el-col>
        </el-row>
        <div class="detail_title">绑定设备信息</div>
        <ul class="detail_form">
            <li>
                <span>设备号：</span>
                <b>{{ (detailForm && detailForm.deviceNumber) || '--' }}</b>
            </li>
            <li>
                <span>设备类型：</span>
                <b>{{ String(detailForm.deviceType) == '0' ? 'OBD' : String(detailForm.deviceType) == '1' ? '双摄' : String(detailForm.deviceType) == '2' ? '单摄' : '--' }}</b>
            </li>
            <li>
                <span>绑定状态：</span>
                <b>{{ detailForm && detailForm.bindStatus == 1 ? '已绑定' : '未绑定' }}</b>
            </li>
            <li>
                <span>激活状态：</span>
                <b>{{ detailForm && detailForm.activationStatus == 1 ? '已激活' : '未激活' }}</b>
            </li>
            <li>
                <span>设备状态：</span>
                <b>{{ detailForm && detailForm.onlineStatus == 1 ? '在线' : detailForm && detailForm.onlineStatus == 2 ? '离线' : '--' }}</b>
            </li>
        </ul>
        <div class="detail_title">运营公司</div>
        <ul class="detail_form">
            <li>
                <b>{{ detailForm && detailForm.sendDeviceOrg != null ? detailForm.sendDeviceOrg : '--' }}</b>
            </li>
        </ul>
        <div class="detail_title">行程数据</div>
        <el-row class="detail_form el-row" v-if="pathStr == '/devices/deviceList'">
            <el-col :span="8">
                行程总里程：<b>{{ detailForm && detailForm.totalMileage != null ? detailForm.totalMileage : '--' }}km</b>
            </el-col>
            <el-col :span="8">
                行程总时长：<b>{{ detailForm && detailForm.totalDuration != null ? detailForm.totalDuration : '--' }}h</b>
            </el-col>
            <el-col :span="8">
                总告警次数：<b>{{ detailForm && detailForm.alarmCount != null ? detailForm.alarmCount : '--' }}次</b>
            </el-col>
        </el-row>
        <ul class="detail_form" v-else>
            <li>
                <span>行程数量：</span>
                <b>{{ detailForm && detailForm.totalTripNum != null ? detailForm.totalTripNum : '--' }} 次</b>
            </li>
            <li>
                <span>行程总里程：</span>
                <b>{{ detailForm && detailForm.totalMileage != null ? detailForm.totalMileage : '--' }} km</b>
            </li>
            <li>
                <span>行程总时长：</span>
                <b>{{ detailForm && detailForm.totalDuration != null ? detailForm.totalDuration : '--' }} h</b>
            </li>
            <li>
                <span>总报警次数（三急一超）：</span>
                <b>{{ detailForm && detailForm.totalAlarm ? Math.ceil(detailForm.totalAlarm / 1) : '--' }} 次</b>
            </li>
        </ul>
        <template v-if="detailForm && detailForm.deviceType == 0">
            <div class="detail_title">
                插拔记录
                <span>（仅展示最近十条记录）</span>
            </div>
            <div class="table_box">
                <el-table ref="multipleTable" :data="detailForm.alarmRecords" style="width: 100%">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="alarmName" label="插拔操作"></el-table-column>
                    <el-table-column prop="time" label="插拔时间"></el-table-column>
                    <!-- <el-table-column prop="lon" label="参考经度（东经）"></el-table-column> -->
                    <!-- <el-table-column prop="lat" label="参考纬度（北纬）"></el-table-column> -->
                </el-table>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'DeviceDetail',
    props: {
        detailForm: Object
    },
    data() {
        return {
            tableData: [],
            pathStr: ''
        };
    },
    mounted() {
        this.pathStr = this.$route.path;
    },
    methods: {
        beforeClose(done) {
            this.$emit('beforeClose');
        }
    }
};
</script>
<style lang="less" scoped>
.detail-content {
    height: 540px;
    overflow-y: auto;
}

.detail_form {
    border-bottom: 1px dashed #e7e7e7;
    display: flex;
    flex-wrap: wrap;
    .el-col {
        font-size: 0.18rem;
    }
    li {
        min-width: 20%;
        font-size: 0.18rem;
        color: #828893;
        padding: 0 0 0.3rem;
        // margin-right: 20px;
    }
    .link {
        color: rgba(5, 169, 197, 1);
        cursor: pointer;
    }
    b {
        font-weight: 600;
        color: #686975;
    }
}
.el-row {
    padding-bottom: 40px;
}
</style>
